function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as r } from "./index.es33.js";
import { useRef as G, Fragment as J } from "react";
import { Typography as K } from "./index.es35.js";
import "./index.es36.js";
import { VariableWrapper as L } from "./index.es128.js";
import { CopyText as M } from "./index.es109.js";
import { Spinner as O } from "./index.es424.js";
import { getInputClassNames as Q, getTextAreaStyles as X, textAreaStyles as Y } from "./index.es425.js";
import Z from "./index.es124.js";

var i = function i(_ref) {
  var l = _ref.maxHeight,
      n = _ref.minHeight,
      a = _ref.height,
      j = _ref.isLoading,
      x = _ref.isAutosize,
      f = _ref.autoHeight,
      o = _ref.isDisabled,
      u = _ref.inputRef,
      s = _ref.value,
      y = _ref.setIsFocused,
      N = _ref.maxLength,
      T = _ref.onChange,
      d = _ref.onBlur,
      C = _ref.onPaste,
      S = _ref.placeholder,
      p = _ref.withCopy,
      A = _ref.options,
      R = _ref.isFocused,
      g = _ref.isError,
      v = _ref.noOptionsText,
      B = _ref.onAddVariable,
      F = _ref.isAddVariablePending,
      P = _ref.onOptionClick,
      W = _ref.validate,
      t = _ref.isVariable,
      m = _ref.isEmoji;

  var I = t || m,
      U = t && m,
      c = G(null),
      _Q = Q({
    isVariable: t,
    isAutosize: x,
    withCopy: p,
    isDisabled: o,
    isControl: I,
    bothControls: U
  }),
      k = _Q.wrapperClassName,
      q = _Q.textAreaClassName,
      w = t ? L : J;

  return r.jsx("div", {
    className: k,
    style: X({
      isVariable: t,
      autoHeight: f,
      height: a,
      minHeight: n,
      maxHeight: l
    }),
    children: j ? r.jsx(O, {}) : r.jsxs(r.Fragment, {
      children: [r.jsx(w, _objectSpread(_objectSpread({}, t ? {
        textareaRef: u,
        mirrorRef: c,
        value: s || "",
        options: A,
        isFocused: R,
        isDisabled: o,
        isError: g,
        noOptionsText: v,
        onAddVariable: B,
        onOptionClick: P,
        validate: W,
        onChange: T,
        isAddVariablePending: F,
        isPopupPositionUnderVariable: t,
        isEmoji: m
      } : {}), {}, {
        children: r.jsx(K.Body2, {
          className: q,
          as: "textarea",
          ref: u,
          disabled: o,
          value: s,
          maxLength: N,
          placeholder: S,
          onChange: function onChange(e) {
            return T === null || T === void 0 ? void 0 : T(e.target.value);
          },
          onFocus: function onFocus() {
            return y(!0);
          },
          rows: n ? 1 : 0,
          onBlur: function onBlur(e) {
            y(!1), d === null || d === void 0 ? void 0 : d(e);
          },
          onPaste: C,
          style: Y({
            autoHeight: f,
            height: a,
            isAutosize: x,
            minHeight: n,
            maxHeight: l,
            withCopy: p,
            isDisabled: o
          }),
          onScroll: function onScroll(e) {
            c.current && (c.current.scrollTop = e.currentTarget.scrollTop);
          }
        })
      })), r.jsx("div", {
        className: Z.copyTextContainer,
        children: r.jsx(M, {
          withCopy: p,
          value: s,
          isDisabled: o
        })
      })]
    })
  });
};

export { i as TextAreaInput };